export const SLICE = 'users';

export const getShouldReload = state => state[SLICE].reload;
